<template>
  <div id="dashboard" class="row w-100 pl-5 justify-content-start" :style="{
    //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
    paddingRight: '0px',
    margin: '0px',
    padding: '0px !important',
  }">
    <div class="container-fluid">
      <div>
        <!-- <div class="row">
          <div class="h3">設備管理</div>
        </div> -->
        <!--設備清單-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bg-white">
            <!-- <div class="h5 mb-0 font-weight-bold text-primary">
              設備篩選條件
            </div> -->

            <form class="row g-3">
              <div class="col-md-3">
                <label for="inputEmail4" class="form-label">風景區</label>
                <select class="form-control" v-model="selectScenicAreaId">
                  <option value="-1">請選擇</option>
                  <option v-for="(list, index) in scenicAreaList" :key="index" :value="list.id">{{ list.name }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="inputPassword4" class="form-label">地點</label>
                <select class="form-control" v-model="selectPublicPlaceId">
                  <option value="-1">請選擇</option>
                  <option v-for="(list, index) in publicPlaceList" :key="index" :value="list.id">
                    {{ list.groupPosition }}-{{ list.name }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="inputPassword4" class="form-label">設備種類</label>
                <select class="form-control" v-model="selectDeviceType">
                  <option value="">請選擇</option>
                  <option
                    v-for="(list, index) in deviceTypeList"
                    :key="index" :value="list.enumType">{{ list.description }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="inputPassword4" class="form-label">狀態</label>
                <!-- <select class="form-control" id="SensorSN" name="SensorSN" v-model="selectDisableStatus"> -->
                <select class="form-control" id="SensorSN" name="SensorSN" v-model="selectConnectStatus">

                  <option v-for="(list, index) in connectStatusList" :key="index" :value="list.enumType">
                    {{ list.description }}</option>
                </select>
              </div>

              <div class="col-md-6 d-flex align-items-end">
                <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryDevice" >
                  <i class="fas fa-search"></i> 查詢
                </button>
                <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1"  @click="addDevice()"> 
                  <i class="fas fa-plus"></i> 新增設備
                </button>
              </div>
            </form>

            <hr />
            <div class="row">
              <div class="col-12">
                <table id="deviceTable" class="w3-table-all table table-hover table-striped">
                  <thead :class="tableThStyle" class="table-dark">
                    <tr>
                      <th scope="col" width="10%">設備ID</th>
                      <th scope="col" width="10%">風景區</th>
                      <th scope="col">地點</th>
                      <th scope="col">設備種類</th>
                      <th scope="col">設備名稱</th>
                      <th scope="col">影像監控ID</th>
                      <th scope="col">設備識別ID</th>
                      <th scope="col">設備IP</th>
                      <th scope="col">連線狀態</th>
                      <th scope="col">設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in devicesList" :key="index" :class="tableCenterStyle">
                      <td>{{ item.id }}</td>
                      <td>{{ item.scenicAreaName }}</td>
                      <!-- <td>{{ (item.publicPlaceId) }}</td> -->
                      
                      <td>{{ publicPlaceListInDL(item.publicPlaceId) }}</td>
                      <td>{{ Const.EAST_COAST_DEVICE_TYPE_ENUM[item.operationType] }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.operationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA ? item.identifierSetting : '-' }}</td>
                      <td>{{ item.operationType !== Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA ? item.identifierSetting : '-' }}</td>
                      <td>{{ item.ip }}</td>
                      <td>{{ item.isConnected }}</td>
                      <td class="">
                        <button class="btn btn-info mx-1  p-2 mb-1" data-bs-toggle="modal" data-bs-target="#exampleModalCenter"
                          @click="editDevice(item)">
                          編輯</button>
                        <button class="btn btn-danger mx-1 p-2 mb-1" @click="delteDevice(item)">刪除</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增設備Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" ref="dialogModal" role="dialog"
      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5" id="exampleModalCenterTitle">
              {{ pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? '編輯' : '新增' }}設備
            </div>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body h6">
            <form>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="exampleFormControlSelect1" disabled>
                      <span class="text-danger">*</span>風景區
                    </label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="selectScenicAreaId"
                      :disabled="pageMode === Const.DIALOG_MODE.EDIT_DEVICE">
                      <option value="-1">請選擇</option>
                      <option v-for="(list, index) in scenicAreaList" :key="index" :value="list.id">{{ list.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1">
                      <span class="text-danger">*</span>地點
                    </label>
                    <select class="form-control" v-model="selectPublicId">
                      <option value="-1">請選擇</option>
                      <option v-for="(list, index) in publicPlaceListInDL" :key="index" :value="list.id">
                        {{ list.groupPosition }}-{{ list.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlSelect1">
                      <span class="text-danger">*</span>設備種類
                    </label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="selectOperationType"
                      :disabled="pageMode === Const.DIALOG_MODE.EDIT_DEVICE">
                      <option value="">請選擇</option>
                      <option
                        v-for="(list, index) in deviceTypeList"
                        :key="index" :value="list.enumType">{{ list.description }}</option>
                    </select>
                  </div>

                  <div class="form-group"
                    v-if='selectOperationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA'>
                    <label for="videoPurpose">
                      <span class="text-danger">*</span>攝影機種類
                    </label>
                    <select class="form-control" v-model="selectVideoPurposeType">
                      <option value="-1">請選擇</option>
                      <option v-for="(list, index) in videoPurposeList" :key="index" :value="list">{{ Const.VIDEO_PURPOSE_TYPE_CHINESE[list] }}</option>
                    </select>
                  </div>

                  <div class="form-group" v-if='pageMode === Const.DIALOG_MODE.EDIT_DEVICE'>
                    <label for="exampleInputPassword1"><span class="text-danger">*</span>設備ID</label>
                    <input type="text" class="form-control" v-model="selectDeviceId"
                      :disabled="pageMode === Const.DIALOG_MODE.EDIT_DEVICE" />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputPassword1"><span class="text-danger">*</span>設備名稱</label>
                    <input type="text" class="form-control" v-model="selectDeviceName" />
                  </div>

                  <div class="form-group">
                    <label v-if='selectOperationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA' for="exampleInputPassword1">影像監控ID</label>
                    <label v-if='selectOperationType !== Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA&&pageMode === Const.DIALOG_MODE.EDIT_DEVICE' for="exampleInputPassword1">設備識別ID</label>
                    <label v-if= 'pageMode === Const.DIALOG_MODE.ADD_DEVICE' for="exampleInputPassword1">影像監控ID/設備識別ID</label>

                    <input type="text" class="form-control" v-model="selectIdentifierSetting" />
                  </div>
                  <div class="form-check"
                    v-if='selectOperationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA'>
                    <input type="checkbox" class="form-check-input" id="exampleCheck2"
                      v-model="selectIsMovable" :disabled="pageMode === Const.DIALOG_MODE.EDIT_DEVICE" />
                    <label class="form-check-label" for="exampleCheck2">
                      活動攝影機
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group">
                    <label for="exampleInputEmail1">經度</label>
                    <input type="number" class="form-control" v-model.number="selectLongitude" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1">緯度</label>
                    <input type="number" class="form-control" v-model.number="selectLatitude" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1">IP</label>
                    <input type="text" class="form-control" v-model="selectDeviceIP" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1">連接埠</label>
                    <input type="number" class="form-control" v-model.number="selectDevicePort" />
                  </div>
                  <div class="form-group"
                    v-if='selectOperationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA'>
                    <label for="streamId">影像辨識 ID</label>
                    <input type="text" class="form-control" v-model="selectDeviceStreamId" />
                  </div>
                  <div class="form-group"
                    v-if='selectOperationType === Const.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA'>
                    <label for="streamId">串流 Url</label>
                    <input type="text" class="form-control" v-model="selectDeviceStreamUrl" />
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1"
                      v-model="selectIsDisable" />
                    <label class="form-check-label" for="exampleCheck1">
                      停用
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="dismissDL">
              取消
            </button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="executeDL">
              {{ pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? '編輯' : '新增' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'

export default {
  name: "Home",
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      selectScenicAreaId: -1,
      selectPublicPlaceId: -1,
      deviceTypeList: [],
      selectDeviceType: '',
      devicesList: [],
      videoPurposeList: [],
      selectVideoPurpose: '',
      connectStatusList: [],
      selectConnectStatus: CONST.DEVICE_DISABLE_STATUS.ALL.enumType,
      pageMode: CONST.DIALOG_MODE.VIEW,
      edittingDeviceData: {},

      selectScenicAreaId: -1,
      selectPublicId: null,
      selectOperationType: null,
      selectVideoPurposeType: null,
      selectDeviceId: null,
      selectDeviceName: null,
      selectIdentifierSetting: null,
      selectIsMovable: null,
      selectLongitude: null,
      selectLatitude: null,
      selectDeviceIP: null,     
      selectDevicePort: null,
      selectDeviceStreamId: null,
      selectDeviceStreamUrl: null,
      selectIsDisable: false,
    };
  },
  computed: {
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),

    publicPlaceList() {
      if (this.selectScenicAreaId < 0) {
        this.selectPublicPlaceId = -1
        return []
      }
      const condition = {}
      condition[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID] = this.selectScenicAreaId
      return this.$store.getters['publicPlace/getPublicPlaceData'](condition)
    },
    publicPlaceListInDL() {
      
      if (this.selectScenicAreaId < 0) {
        this.selectPublicId = -1
        return []
      }
      const condition = {}
      condition[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID] = this.selectScenicAreaId
      return this.$store.getters['publicPlace/getPublicPlaceData'](condition)
    }
  },
  methods: {
    openModal() {
      $(this.$refs.dialogModal).modal('show')
    },
    closeModal() {
      $(this.$refs.dialogModal).modal('hide')
    },
    initEdittingDeviceData() {
      this.edittingDeviceData = {
        // id: '', 
        // type: '', 在地圖上使用  iisi、weather...
        identifierSetting: '',
        ip: '',
        isConnected: false,
        isDeleted: false, //V post 必填欄位
        isDisabled: false, //V
        createTime: '',//V
        latitude: 0,
        longitude: 0,
        name: '',
        operationType: '', //V
        port: null,
        publicPlaceName: '',
        publicPlaceId: -1, //V
        scenicAreaId: -1,
        scenicAreaName: '',
        streamId: null, // VideoCamera欄位
        streamUrl: '', // VideoCamera欄位
        videoPurposeType: '', // VideoCamera欄位
        isMovable: false, // VideoCamera欄位
        triigerTime: null, // callHelpSink欄位
        isTrigger: false, // callHelpSink欄位

      }

      this.editDeviceDataToSelectData(this.edittingDeviceData)
    },
    initTable: function () {
      this.table = $("#deviceTable").DataTable({
        aoColumns: [
          ...new Array($("table th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    async queryDevice() {
      let devicesList = []
      if (this.selectPublicPlaceId > 0) {
        // 有選擇景區、地點，設備種類可選可不選
        await this.$store.dispatch('publicPlace/getDeviceByPublicPlaceId', { id: this.selectPublicPlaceId })
        devicesList = this.$store.getters['publicPlace/getPublicPlaceDevice'](this.selectDeviceType)

      } else if (this.selectScenicAreaId > -1) {
        // 只有選擇風景區，設備種類可選可不選
        await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
        devicesList = this.$store.getters['scenicArea/getScenicAreaDevice'](this.selectDeviceType)

      } else {
        //只有選種類或全不選
        await this.$store.dispatch('deviceApi/getDevice', { deviceType: this.selectDeviceType })
        const devices = this.$store.getters['deviceApi/getDeviceData']
        if (Utils.isEmptyString(this.selectDeviceType)) {
          devicesList = devices
        } else {
          devicesList = devices[this.selectDeviceType]
        }
      }

      switch (this.selectConnectStatus) { // 目前狀態只有停用
        case CONST.DEVICE_CONNECT_STATUS.CONNECT.enumType:
          devicesList = devicesList.filter(d => d.isConnected === true)
          break

          case CONST.DEVICE_CONNECT_STATUS.DISCONNECT.enumType:
          devicesList = devicesList.filter(d => d.isConnected === false)
          break
          // case CONST.DEVICE_DISABLE_STATUS.DISABLE.enumType:
          // devicesList = devicesList.filter(d => d.isDisabled === true)
          // break
      }

      this.devicesList = devicesList
      this.updateTable()
    },
    addDevice() {
      this.initEdittingDeviceData()
      this.pageMode = CONST.DIALOG_MODE.ADD_DEVICE
      this.openModal()
    },
    editDevice(item) {
      this.edittingDeviceData = item
      this.edittingDeviceData.scenicAreaId = this.getscenicAreaIdFromName(item.scenicAreaName)

      this.editDeviceDataToSelectData(item)

      this.pageMode = CONST.DIALOG_MODE.EDIT_DEVICE
    },
    delteDevice(item) {
      if (confirm("確認刪除設備")) {
        this.deleteDevice(item)
      }
    },
    getscenicAreaIdFromName(name) {
      // device 沒有 scenicAreaId
      const target = this.scenicAreaList.find(area => {
        return area.name === name
      })

      return target ? target.id : ''
    },
    dismissDL() {
      this.pageMode === CONST.DIALOG_MODE.VIEW
    },
    executeDL() {
      switch (this.pageMode) {
        case CONST.DIALOG_MODE.EDIT_DEVICE:
          this.updateDevice()
          break

        case CONST.DIALOG_MODE.ADD_DEVICE:
          this.createDevice()
          break
      }

      this.$store.dispatch('videoCamera/getCCTV') // 確保videoCamera也是新的資料(給map使用)
    },

    editDeviceDataToSelectData(item) { //將editDevice寫進暫存值
      this.selectScenicAreaId = this.edittingDeviceData.scenicAreaId
      this.selectPublicId = item.publicPlaceId
      this.selectOperationType = item.operationType
      this.selectVideoPurposeType = item.videoPurposeType
      this.selectDeviceId = item.id
      this.selectDeviceName = item.name
      this.selectIdentifierSetting = item.identifierSetting
      this.selectIsMovable = item.isMovable
      this.selectLongitude = item.longitude
      this.selectLatitude = item.latitude
      this.selectDeviceIP = item.ip
      this.selectDevicePort = item.port
      this.selectDeviceStreamId = item.streamId
      this.selectDeviceStreamUrl = item.streamUrl
      this.selectIsDisable = item.isDisabled
    },

    selectDataToEdittingDeviceData() {
      this.edittingDeviceData.scenicAreaId = this.selectScenicAreaId
      this.edittingDeviceData.publicPlaceId = this.selectPublicId
      this.edittingDeviceData.operationType = this.selectOperationType
      this.edittingDeviceData.videoPurposeType = this.selectVideoPurposeType
      this.edittingDeviceData.id = this.selectDeviceId
      this.edittingDeviceData.name = this.selectDeviceName
      this.edittingDeviceData.identifierSetting = this.selectIdentifierSetting
      this.edittingDeviceData.isMovable = this.selectIsMovable
      this.edittingDeviceData.longitude = this.selectLongitude
      this.edittingDeviceData.latitude = this.selectLatitude 
      this.edittingDeviceData.ip = this.selectDeviceIP
      this.edittingDeviceData.port = this.selectDevicePort
      this.edittingDeviceData.streamId = this.selectDeviceStreamId
      this.edittingDeviceData.streamUrl = this.selectDeviceStreamUrl
      this.edittingDeviceData.isDisabled = this.selectIsDisable
    },

    async updateDevice() {
      this.selectDataToEdittingDeviceData()
      const result = await this.$store.dispatch('deviceApi/putDevice', this.edittingDeviceData)

      if (result.success) {
        this.closeModal()
      } else {
        alert('編輯失敗')
      }
    },

    async createDevice() {
      this.selectDataToEdittingDeviceData()
      const device = Object.assign({}, this.edittingDeviceData)
      device.createTime = moment().format()
      delete device.scenicAreaId
      if (device.publicPlaceId === -1) {
        device.publicPlaceId = null
      }
      const result = await this.$store.dispatch('deviceApi/postDevice', device)

      if (result.success) {
        this.queryDevice()
        this.closeModal()
      } else {
        alert('新增失敗')
      }
    },

    async deleteDevice(device) {
      const result = await this.$store.dispatch('deviceApi/deleteDevice', device.id)
      this.queryDevice()
      this.$store.dispatch('videoCamera/getCCTV') // 確保videoCamera也是新的資料(給map使用)
    }
  },
  async mounted() {
    this.updateTable()
    this.initEdittingDeviceData()

    await this.$store.dispatch('deviceApi/getDevcieType')
    this.deviceTypeList = this.$store.getters['deviceApi/getDeviceType']
    this.videoPurposeList = Object.values(CONST.VIDEO_PURPOSE_TYPE)
    this.connectStatusList = CONST.DEVICE_CONNECT_STATUS;

    await this.$store.dispatch('publicPlace/getPublicPlace', { placeType: '' })
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th{width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
